import { Container } from "react-bootstrap";
import Wrapper from "../../Wrapper";
import VehicleTabs from "./VehicleTabs";

const Vehicle = () => {

    return (
        <Wrapper>
            <div className="employee">
                <Container fluid>
                    <VehicleTabs />
                </Container>
            </div>
        </Wrapper>
    );
}
export default Vehicle;